import * as React from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useState } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router';
import moment from 'moment/moment';
import { useParams } from 'react-router';
import { useEffect } from 'react';
import { getApi } from 'views/services/api';
import AddComplaint from './AddComplaint';
import DeleteComplaint from './DeleteComplaint';
import { Container, Card, CardContent, Stack, Chip, Divider, alpha, useTheme, Toolbar, Avatar } from '@mui/material';
import {
  BugReport as BugIcon,
  CheckCircle as ResolvedIcon,
  Schedule as PendingIcon,
  CalendarToday as CalendarIcon,
  Description as DescriptionIcon,
  Category as CategoryIcon,
  Support as SupportIcon,
  Assignment as ReportIcon
} from '@mui/icons-material';

export default function ComplaintDashboard() {
  const theme = useTheme();
  const navigate = useNavigate();
  const [value, setValue] = React.useState('1');
  const [openAdd, setOpenAdd] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);
  const handleOpenDeleteLead = () => setDeleteDialogOpen(true);
  const handleCloseDeleteLead = () => setDeleteDialogOpen(false);

  //function for fetching property data based on the property id
  // ----------------------------------------------------------------------
  const [complaintData, setComplaintData] = useState([]);
  const params = useParams();
  const complaintId = params.id;
  console.log('in complaint dashboard ', complaintId);

  const fetchcomplaintData = async () => {
    try {
      const response = await getApi(`api/complaint/view/${complaintId}`);
      console.log('hyyy =>', response);
      setComplaintData(response?.data?.mergedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchcomplaintData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openAdd, deleteDialogOpen]);

  // Función para obtener el icono según el tipo
  const getTypeIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'bug':
        return <BugIcon sx={{ fontSize: 24, color: theme.palette.error.main }} />;
      case 'feature':
        return <ReportIcon sx={{ fontSize: 24, color: theme.palette.info.main }} />;
      case 'support':
        return <SupportIcon sx={{ fontSize: 24, color: theme.palette.warning.main }} />;
      default:
        return <ReportIcon sx={{ fontSize: 24, color: theme.palette.primary.main }} />;
    }
  };

  // Función para obtener el color del tipo
  const getTypeColor = (type) => {
    switch (type?.toLowerCase()) {
      case 'bug':
        return 'error';
      case 'feature':
        return 'info';
      case 'support':
        return 'warning';
      default:
        return 'primary';
    }
  };

  return (
    <>
      <DeleteComplaint open={deleteDialogOpen} handleClose={handleCloseDeleteLead} />
      <AddComplaint open={openAdd} handleClose={handleCloseAdd} />

      <Container maxWidth="xl" sx={{ py: 3 }}>
        {/* Header Section */}
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 3,
            background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.dark} 100%)`,
            color: 'white',
            borderRadius: 3
          }}
        >
          <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Box>
              <Typography variant="h4" fontWeight={700} gutterBottom>
                Detalle del Reporte de Soporte
              </Typography>
              <Typography variant="body1" sx={{ opacity: 0.9 }}>
                Información completa del reporte técnico #{complaintId}
              </Typography>
            </Box>
            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={() => navigate(-1)}
              sx={{
                borderColor: 'rgba(255,255,255,0.3)',
                color: 'white',
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)'
                }
              }}
            >
              Volver
            </Button>
          </Stack>
        </Paper>

        <TabContext value={value}>
          <Card sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Box sx={{ borderBottom: '1px solid', borderColor: 'divider' }}>
              <TabList
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                sx={{
                  px: 3,
                  '& .MuiTab-root': {
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1rem'
                  }
                }}
              >
                <Tab label="Información del Reporte" value="1" />
              </TabList>
            </Box>

            <TabPanel value="1" sx={{ p: 0 }}>
              <Box sx={{ p: 4 }}>
                {/* Status Header */}
                <Box sx={{ mb: 4 }}>
                  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
                    <Stack direction="row" alignItems="center" spacing={2}>
                      <Avatar
                        sx={{
                          width: 56,
                          height: 56,
                          bgcolor: alpha(theme.palette.error.main, 0.1)
                        }}
                      >
                        {getTypeIcon(complaintData.type)}
                      </Avatar>
                      <Box>
                        <Typography variant="h5" fontWeight={600}>
                          Reporte de {complaintData.type || 'Soporte'}
                        </Typography>
                        <Chip
                          label={complaintData.status === true ? 'Resuelto' : 'Pendiente'}
                          color={complaintData.status === true ? 'success' : 'warning'}
                          variant="filled"
                          icon={complaintData.status === true ? <ResolvedIcon /> : <PendingIcon />}
                          sx={{ mt: 1, fontWeight: 600 }}
                        />
                      </Box>
                    </Stack>

                    <Stack direction="row" spacing={2}>
                      <Button
                        variant="contained"
                        startIcon={<AddIcon />}
                        onClick={handleOpenAdd}
                        color="primary"
                        sx={{ textTransform: 'none', fontWeight: 600 }}
                      >
                        Nuevo Reporte
                      </Button>
                      <Button
                        variant="outlined"
                        startIcon={<DeleteIcon />}
                        onClick={handleOpenDeleteLead}
                        color="error"
                        sx={{ textTransform: 'none', fontWeight: 600 }}
                      >
                        Eliminar
                      </Button>
                    </Stack>
                  </Stack>
                </Box>

                <Divider sx={{ mb: 4 }} />

                {/* Information Grid */}
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}>
                    <Card
                      variant="outlined"
                      sx={{
                        p: 3,
                        height: '100%',
                        borderRadius: 2,
                        border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
                      }}
                    >
                      <Stack spacing={3}>
                        <Box>
                          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                            <CategoryIcon sx={{ fontSize: 20, color: theme.palette.primary.main }} />
                            <Typography variant="h6" fontWeight={600} color="primary">
                              Tipo de Reporte
                            </Typography>
                          </Stack>
                          <Chip
                            label={complaintData.type || 'No especificado'}
                            color={getTypeColor(complaintData.type)}
                            variant="outlined"
                            sx={{
                              fontWeight: 500,
                              textTransform: 'capitalize'
                            }}
                          />
                        </Box>

                        <Box>
                          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                            <CalendarIcon sx={{ fontSize: 20, color: theme.palette.info.main }} />
                            <Typography variant="h6" fontWeight={600} color="primary">
                              Fecha de Creación
                            </Typography>
                          </Stack>
                          <Typography variant="body1" fontWeight={500}>
                            {complaintData.createdDate
                              ? moment(complaintData.createdDate).format('DD/MM/YYYY [a las] HH:mm')
                              : 'No disponible'}
                          </Typography>
                          {complaintData.createdDate && (
                            <Typography variant="caption" color="text.secondary">
                              Hace {moment(complaintData.createdDate).fromNow()}
                            </Typography>
                          )}
                        </Box>
                      </Stack>
                    </Card>
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Card
                      variant="outlined"
                      sx={{
                        p: 3,
                        height: '100%',
                        borderRadius: 2,
                        border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`
                      }}
                    >
                      <Stack direction="row" alignItems="flex-start" spacing={1} sx={{ mb: 2 }}>
                        <DescriptionIcon sx={{ fontSize: 20, color: theme.palette.secondary.main, mt: 0.5 }} />
                        <Typography variant="h6" fontWeight={600} color="primary">
                          Descripción del Problema
                        </Typography>
                      </Stack>
                      <Box
                        sx={{
                          p: 2,
                          backgroundColor: alpha(theme.palette.grey[500], 0.05),
                          borderRadius: 2,
                          minHeight: 120,
                          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
                        }}
                      >
                        <Typography
                          variant="body1"
                          sx={{
                            lineHeight: 1.6,
                            whiteSpace: 'pre-wrap'
                          }}
                        >
                          {complaintData.description || 'No se proporcionó una descripción detallada.'}
                        </Typography>
                      </Box>
                    </Card>
                  </Grid>
                </Grid>

                {/* Status Information */}
                <Box sx={{ mt: 4 }}>
                  <Card
                    sx={{
                      p: 3,
                      background:
                        complaintData.status === true
                          ? `linear-gradient(135deg, ${alpha(theme.palette.success.main, 0.1)} 0%, ${alpha(
                              theme.palette.success.main,
                              0.05
                            )} 100%)`
                          : `linear-gradient(135deg, ${alpha(theme.palette.warning.main, 0.1)} 0%, ${alpha(
                              theme.palette.warning.main,
                              0.05
                            )} 100%)`,
                      border: `1px solid ${alpha(
                        complaintData.status === true ? theme.palette.success.main : theme.palette.warning.main,
                        0.2
                      )}`,
                      borderRadius: 2
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={2}>
                      {complaintData.status === true ? (
                        <ResolvedIcon sx={{ fontSize: 28, color: theme.palette.success.main }} />
                      ) : (
                        <PendingIcon sx={{ fontSize: 28, color: theme.palette.warning.main }} />
                      )}
                      <Box>
                        <Typography variant="h6" fontWeight={600} color={complaintData.status === true ? 'success.main' : 'warning.main'}>
                          Estado: {complaintData.status === true ? 'Resuelto' : 'Pendiente'}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {complaintData.status === true
                            ? 'Este reporte ha sido resuelto por el equipo de soporte'
                            : 'Este reporte está en cola de atención del equipo de soporte'}
                        </Typography>
                      </Box>
                    </Stack>
                  </Card>
                </Box>
              </Box>
            </TabPanel>
          </Card>
        </TabContext>
      </Container>
    </>
  );
}
